var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10v3.2a.8.8 0 00.8.8h10.4a.8.8 0 00.8-.8V10",
    stroke: "#A8AAAD",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11l-.416.433a.6.6 0 00.831 0L8 11zm-.6-9v9h1.2V2H7.4zm1.015 9.433l4.167-4-.831-.866-4.167 4 .831.866zm0-.866l-4.166-4-.831.866 4.166 4 .831-.866z",
    fill: "#A8AAAD"
  })));
}
export default __webpack_public_path__ + "static/external_download.4d92659c.svg";
export { SvgExternalDownload as ReactComponent };